/**
 * Objects of all clients (`GET /admin/sites`, administrator only) — the client
 * of an object for the administrator's line above the object screen.
 */
import { useQuery } from '@tanstack/react-query';
import type { AdminSitesResponse } from 'shared';

import { api } from '../lib/api-client.js';

export function useAdminSites(enabled: boolean) {
  return useQuery({
    queryKey: ['admin-sites'],
    queryFn: () => api.get<AdminSitesResponse>('/api/admin/sites').then((r) => r.sites),
    enabled,
    staleTime: 60_000,
  });
}
